module.exports = __webpack_public_path__ + "dist/media/ec_comp_blockquotes.3882dc0a.svg";